export const convertToNumber = (
  value: string | null | undefined
): number | null => (value ? Number(value) : null);
